import { motion, useReducedMotion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { useAiAssistant } from "@/modules/marketing/ai/useAiAssistant";
import { cn } from "@/lib/cn";

/**
 * AiAssistantFab — o'ng pastda turuvchi KO'RINADIGAN "AI yordamchi" tugmasi.
 *
 * - Aurora gradient + glow (--brand-gradient)
 * - Sparkles ikon
 * - Bosilganda useAiAssistant.openChat() — generic kontekst bilan panel ochiladi
 * - Panel ochiq paytda yashiriladi (drawer ustiga tushib qolmasin)
 * - Ctrl+J ham panelni ochadi (AppShell handler) — bu tugma uni dublikatlamaydi,
 *   sichqoncha foydalanuvchilari uchun ko'rinadigan kirish nuqtasi.
 */
export function AiAssistantFab() {
  const open = useAiAssistant((s) => s.open);
  const openChat = useAiAssistant((s) => s.openChat);
  const reduceMotion = useReducedMotion();

  if (open) return null;

  return (
    <motion.button
      type="button"
      onClick={() => openChat()}
      aria-label="AI yordamchi"
      title="AI yordamchi (⌘J)"
      initial={{ opacity: 0, scale: reduceMotion ? 1 : 0.85 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: reduceMotion ? 1 : 1.05 }}
      whileTap={{ scale: 0.96 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className={cn(
        "fixed bottom-6 right-6 z-[60] flex items-center gap-2 rounded-full",
        "px-4 py-3 text-sm font-semibold text-[var(--text-on-brand)]",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-primary)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-base)]",
      )}
      style={{
        background: "var(--brand-gradient)",
        boxShadow:
          "0 10px 30px -8px rgba(139,92,246,0.55), 0 0 0 1px var(--brand-primary-border)",
      }}
    >
      <Sparkles className="h-4 w-4" aria-hidden strokeWidth={2.25} />
      <span className="hidden sm:inline">AI yordamchi</span>
    </motion.button>
  );
}
